import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { AdminContext } from '../contexts/admin.context';

import { securityCodeSchema } from '../schema/login.schema';
import Button from '../components/common/Button';
import AdminInput from '../components/common/AdminInput';
import { verifySecurityCodeAPI } from '../service';
import { WksMFLogo } from '../assets/logos';
import { useTranslation } from 'react-i18next';
import Spinner from '../components/common/Spinner';
import { AuthHeader, CrossBackButton } from '../components';
import { getTranslation } from '../utils/translation';

const SecurityCode = () => {
  const { themeId: theme, teamType } = useContext(AdminContext);

  const navigate = useNavigate();
  const basePath = `/${theme}/${teamType}`;

  const location = useLocation();
  const email = location?.state?.email;
  const { t } = useTranslation();

  if (!email) navigate(-1);

  const submitHandler = async (formValues) => {
    try {
      const formattedFormValues = {
        token: formValues.securityCode
      };
      const response = await verifySecurityCodeAPI(formattedFormValues, theme, teamType);
      if (response.status === 200 || response.status === 203)
        navigate(basePath + '/password-reset-success', { state: { email: email } });
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("les informations d'identification invalides");
        }
        if (error.response.status === 403) {
          toast.error("Votre compte n'est pas actif");
        }
      }
      console.error('ERROR', error);
    } finally {
      formik.setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      securityCode: ''
    },
    validationSchema: securityCodeSchema,
    onSubmit: submitHandler
  });

  return (
    <>
      {/* <AuthHeader theme={theme} /> */}
      <div className={`flex flex-col md:flex-row`}>
        <CrossBackButton />
        <div className="mx-2 md:mx-auto md:max-w-3xl relative min-h-screen">
          <div className="bg-cblack mt-32 pb-2">
            <h1 className="text-4xl font-bold md:text-cback mb-4">
              {getTranslation(t, 'securityCode.title')}
            </h1>
            <p>
              {/* //get email from navigation params */}
              {getTranslation(t, 'securityCode.description1')} {email}
              {getTranslation(t, 'securityCode.description2')}
            </p>
          </div>

          <form className="py-8 mx-2" onSubmit={formik.handleSubmit}>
            <div className="flex flex-col justify-between">
              <AdminInput
                className={'bg-gray-100'}
                label={getTranslation(t, 'securityCode.input.securityCode.label')}
                placeholder={getTranslation(t, 'securityCode.input.securityCode.placeholder')}
                type="string"
                name="securityCode"
                formik={formik}
                isDark={true}
              />
            </div>
            <div className="mt-6 flex justify-between">
              <Button
                // buttonType={'login'}
                onClick={() => navigate(-1)}>
                {getTranslation(t, 'securityCode.back')}
              </Button>
              <Button buttonType={'login'} disabled={formik?.isSubmitting} type="submit">
                {formik?.isSubmitting && <Spinner color="#ffffff" />}
                {getTranslation(t, 'securityCode.button')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SecurityCode;
